<template>
  <v-autocomplete
    :items="power_plants"
    item-text="name"
    prepend-icon="flash_on"
    label="Planta"
    :v-model="power_plant || ''"
    return-object
    :rules="[(v) => !!v || 'Selecione a Planta que deseja ver fatura']"
  ></v-autocomplete>
</template>

<script>
export default {
  props: ["power_plants", "power_plant"],
};
</script>
